import BubbleChartTooltips from './BubbleChartTooltips';

export default BubbleChartTooltips;
